import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { create } from 'zustand';

const useConfirmDialogStore = create((set) => ({
  title: 'Confirmation',
  messages: [],
  onSubmit: undefined,
  close: () => set({ onSubmit: undefined }),
  cancelText: '',
  confirmText: ''
}));

export const reportDeleteConfirmDialog = (
  onSubmit,
  messages = ['Do you really want to delete all the reports?'],
  title = 'Confirmation',
  cancelText = 'Cancel',
  confirmText = 'Confirm'
) => {
  useConfirmDialogStore.setState({
    messages,
    onSubmit,
    title,
    cancelText,
    confirmText
  });
};

const ReportDeletionConfirmationDialog = () => {
  const { title, messages, onSubmit, close, cancelText, confirmText } =
    useConfirmDialogStore();
  const reportList = useSelector((state) => state.fo.reportsToDelete);
  if (!reportList || reportList.length === 0) {
    messages[0] = "No reports to delete. Please check your input.";
  }
  const formattedReports = reportList.map(report => `${report.tenantCd} / ${report.displayText}`);
  messages.push(...formattedReports);
  return (
    <Dialog open={Boolean(onSubmit)} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={close} size="large">
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        {messages.map((msg, index) => <Typography key={index}>{msg}</Typography>)}
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={close}>
          {cancelText}
        </Button>
        <Button
          color="primary"
          onClick={() => {
            if (onSubmit) {
              onSubmit();
            }
            close();
          }}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ReportDeletionConfirmationDialog;
